import { BigNumber } from 'ethers'
import { getReadableNumber } from 'src/helpers/getReadableNumber'
import { Synth } from 'src/services/GraphService'

export interface QuantityChange {
  change: BigNumber
  isPositive: boolean
}

export function getDescription(
  debtAmountChanged: QuantityChange,
  collateralAmountChanged: QuantityChange,
  synth: Synth,
) {
  const debtPart = debtAmountChanged.isPositive ? 'minting' : 'repaying'
  const collateralPart = collateralAmountChanged.isPositive ? 'depositing' : 'withdrawing'

  return `You will be ${collateralPart} ${getReadableNumber(collateralAmountChanged.change)} ${
    synth.collateral
  } & ${debtPart} ${getReadableNumber(debtAmountChanged.change)} ${synth.synthetic}`
}
